<template>
  <div class="step-three">
    <div class="step-three__wrapper">
      <ElForm
        class="step-three__form form"
        ref="propertyFormRef"
        :rules="rules"
        :model="propertyForm"
      >
        <section class="step-three__form-section">
          <h2 class="step-three__form-section-title">
            Личные данные
          </h2>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="fio"
            >
              <ElAutocomplete
                v-model="propertyForm.fio"
                placeholder="ФИО"
                :fetch-suggestions="fetchFioSuggestions"
                :popper-append-to-body="false"
              >
                <template #prefix>
                  ФИО
                </template>
              </ElAutocomplete>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item form__item--col">
            <ElFormItem
              class="step-three__item-col form__col form__col--half"
              prop="birthDate"
            >
              <ElDatePicker
                v-model="propertyForm.birthDate"
                v-mask="{mask: '9{2}.9{2}.9{4}'}"
                ref="birthPicker"
                type="date"
                placeholder="дд.мм.гггг"
                :default-value="''"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                :picker-options="{ firstDayOfWeek: 1 }"
                disabled
              />

              <span class="form__label">Дата рождения</span>
            </ElFormItem>

            <ElFormItem
              class="step-three__item-col form__col form__col--half"
              prop="gender"
            >
              <ElInput
                v-model="propertyForm.gender"
                placeholder="Пол"
                disabled
              >
                <template #prefix>
                  Пол
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>
          </div>

          <div v-if="!isPropertyTariff" class="step-three__item form__item form__item--col">
            <ElFormItem
              class="step-three__item-col form__col form__col--half"
              prop="height"
            >
              <ElInput
                v-model="propertyForm.height"
                placeholder="Рост, см"
                type="number"
              >
                <template #prefix>
                  Рост, см
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>

            <ElFormItem
              class="step-three__item-col form__col form__col--half"
              prop="weight"
              type="number"
            >
              <ElInput
                v-model="propertyForm.weight"
                placeholder="Вес, кг"
              >
                <template #prefix>
                  Вес
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>
          </div>

          <div v-if="!isPropertyTariff" class="step-three__item form__item form__item--col">
            <ElFormItem
              class="step-three__item-col form__col form__col--half"
              prop="highPressure"
              type="number"
            >
              <ElInput
                v-model="propertyForm.highPressure"
                placeholder="Артериальное давление (верхнее)"
                type="number"
              >
                <template #prefix>
                  Артериальное давление (верхнее)
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>

            <ElFormItem
              class="step-three__item-col form__col form__col--half"
              prop="lowPressure"
              type="number"
            >
              <ElInput
                v-model="propertyForm.lowPressure"
                placeholder="Артериальное давление (нижнее)"
                type="number"
              >
                <template #prefix>
                  Артериальное давление (нижнее)
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item form__item--col">
            <ElFormItem
              class="form__col form__col--half"
              prop="phone"
            >
              <ElInput
                v-model="propertyForm.phone"
                placeholder="Номер телефона"
                v-mask="{regex: '^\\+7 \\([0-9]${3}\\) [0-9]${3} [0-9]${2}-[0-9]${2}'}"
              >
                <template #prefix>
                  Телефон
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>

            <ElFormItem
              class="form__col form__col--half"
              prop="email"
            >
              <ElInput
                v-model="propertyForm.email"
                type="email"
                placeholder="E-mail">
                <template #prefix>
                  E-mail
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>
          </div>
        </section>

        <section class="step-three__form-section">
          <h2 class="step-three__form-section-title">
            Паспортные данные
          </h2>

          <div class="step-three__item form__item form__item--col">
            <ElFormItem
              class="step-three__item-col form__col form__col--half"
              prop="passportNumber"
            >
              <ElInput
                v-model="propertyForm.passportNumber"
                placeholder="Серия и номер паспорта"
                v-mask="{regex: '^[0-9]${2} [0-9]${2} [0-9]${6}'}"
              >
                <template #prefix>
                  Серия и номер паспорта
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>

            <ElFormItem
              class="step-three__item-col form__col form__col--half"
              prop="passportDate"
            >
              <ElDatePicker
                v-model="propertyForm.passportDate"
                v-mask="{mask: '9{2}.9{2}.9{4}'}"
                type="date"
                placeholder="Дата выдачи"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                :picker-options="{ firstDayOfWeek: 1 }"
              />

              <span class="form__label">Дата выдачи</span>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="departmentCode"
            >
              <ElInput
                v-model="propertyForm.departmentCode"
                placeholder="Код подразделения"
                v-mask="{regex: '^[0-9]${3}-[0-9]${3}'}"
                @blur="getIssuedByHandler"
              >
                <template #prefix>
                  Код подразделения
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="issuedBy"
            >
              <ElInput
                v-model="propertyForm.issuedBy"
                placeholder="Кем выдан"
              >
                <template #prefix>
                  Кем выдан
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="registrationAddress"
            >
              <ElAutocomplete class="form__item"
                v-model="propertyForm.registrationAddress"
                :fetch-suggestions="fetchAddressSuggestions"
                placeholder="Адрес регистрации"
                :trigger-on-focus="false"
                value-key="value"
                v-on:input="clearParams"
                @select="handleSelect"
              >
              </ElAutocomplete>
              <template #prefix>
                Адрес регистрации
              </template>

            </ElFormItem>
          </div>
        </section>

        <section class="step-three__form-section">
          <h2 class="step-three__form-section-title">
            О кредите
          </h2>

          <div class="step-three__item form__item form__item--col">
            <ElFormItem
              class="step-three__item-col form__col form__col--half"
              prop="creditBalance"
            >
              <ElInput
                v-model="propertyForm.creditBalance"
                placeholder="Остаток кредита"
                disabled
              >
                <template #prefix>
                  Остаток кредита
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>

            <ElFormItem
              class="step-three__item-col form__col form__col--half"
              prop="interestRate"
            >
              <ElInput
                v-model="propertyForm.interestRate"
                placeholder="Процентная ставка"
                type="number"
              >
                <template #prefix>
                  Процентная ставка
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="manualAnnuity"
              type="number"
            >
              <ElInput
                v-model="propertyForm.manualAnnuity"
                placeholder="Ежемесячный платеж"
              >
                <template #prefix>
                  Ежемесячный платеж
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="loanAgreementNumber"
            >
              <ElInput
                v-model="propertyForm.loanAgreementNumber"
                placeholder="Номер кредитного договора"
              >
                <template #prefix>
                  Номер кредитного договора
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="credit_date"
            >
              <ElDatePicker
                v-model="propertyForm.credit_date"
                v-mask="{mask: '9{2}.9{2}.9{4}'}"
                type="date"
                placeholder="Дата заключения кредитного договора"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                :picker-options="{ firstDayOfWeek: 1 }"
              />

              <span class="form__label">Дата заключения кредитного договора</span>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="dateLoanStart"
            >
              <ElDatePicker
                v-model="propertyForm.dateLoanStart"
                v-mask="{mask: '9{2}.9{2}.9{4}'}"
                type="date"
                placeholder="Дата начала договора страхования"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                :picker-options="{ disabledDate: (time) => getDisabledStartDate(time), firstDayOfWeek: 1 }"
              />

              <span class="form__label">Дата начала договора страхования</span>
            </ElFormItem>
          </div>
        </section>

        <section v-if="!isLifeTariff" class="step-three__form-section">
          <h2 class="step-three__form-section-title">
            Объект страхования
          </h2>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="sameRegisteredAddress"
            >
              <ElCheckbox
                v-model="propertyForm.sameRegisteredAddress"
                label="Совпадает с адресом регистрации"
                @change="sameRegistreredAddressHandler"
              />
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="registrationObjectAddress"
            >
              <ElAutocomplete class="form__item"
                  v-model="propertyForm.registrationObjectAddress"
                  :fetch-suggestions="fetchAddressSuggestions"
                  placeholder="Адрес объекта страхования"
                  :trigger-on-focus="false"
                  value-key="value"
                  v-on:input="clearParamsObject"
                  @select="handleSelectObject"
              >
              </ElAutocomplete>
              <template #prefix>
                Адрес объекта страхования
              </template>

              <i class="form__item-icon-lock" slot="suffix"></i>

            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="yearHouseBuilt"
            >
              <ElInput
                v-model="propertyForm.yearHouseBuilt"
                placeholder="Год постройки дома"
                v-mask="{mask: '9{4}'}"
              >
                <template #prefix>
                  Год постройки дома
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="NumberFloorsHouse"
            >
              <ElInput
                v-model="propertyForm.numberFloorsHouse"
                placeholder="Этажность дома"
                v-mask="{regex: '^[0-9]*'}"
              >
                <template #prefix>
                  Этажность дома
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-three__item-col form__col"
              prop="square"
            >
              <ElInput
                v-model="propertyForm.square"
                placeholder="Площадь"
                type="number"
              >
                <template #prefix>
                  Площадь
                </template>

                <i class="form__item-icon-lock" slot="suffix"></i>
              </ElInput>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem
              class="step-one-form__item-col form__col"
              prop="wallMaterials"
            >
              <ElSelect
                v-model="propertyForm.wallMaterials"
                placeholder="Материал стен"
                :popper-append-to-body="false"
                @change="(item) => formSelectHandler(item, 'wallMaterials')"
                @blur="MaterialBlurHandler"
              >
                <template #prefix>
                  Материал стен
                </template>

                <ElOption
                  v-for="(option, index) in wallMaterials"
                  :key="index"
                  :label="option.label"
                  :value="option.value"
                >
                </ElOption>
              </ElSelect>
            </ElFormItem>
          </div>
        </section>

        <section class="step-three__form-section">
          <div v-if="!isPropertyTariff" class="step-three__item form__item">
            <ElFormItem class="step-three__item-col form__col" prop="personalPolicy">
              <ElCheckboxGroup v-model="propertyForm.personalPolicy">
                <div class="step-three__item-checkbox">
                  <ElCheckbox name="personalPolicy" />
                  <span class="tep-three__item-checkbox-text">
                    Я, {{ fio }} при заключении Полиса страхования на сайте ООО «Зетта Страхование» (<a href="https://www.zettains.ru/" target="_blank">www.zettains.ru</a>), оплатой страховой премии подтверждаю, что <a
                      href="#" download>все вопросы</a> на которые я отвечал на сайте мне понятны, все указанные сведения, являются достоверными и существенными. Обязуюсь письменно сообщать Страховщику обо всех изменениях данных в ответах. С ответственностью за предоставление недостоверных (ложных) сведений ознакомлен и согласен
                </span>
                </div>
              </ElCheckboxGroup>
            </ElFormItem>
          </div>

           <div v-if="!isPropertyTariff" class="step-three__item form__item">
            <ElFormItem class="step-three__item-col form__col" prop="questionnaire">
              <ElCheckboxGroup v-model="propertyForm.questionnaire">
                <div class="step-three__item-checkbox">
                  <ElCheckbox name="questionnaire" />
                  <span class="tep-three__item-checkbox-text">
                    Подтверждаю данные, указанные в <a
                      href="#" download>Анкете о состоянии здоровья застрахованного</a>
                </span>
                </div>
              </ElCheckboxGroup>
            </ElFormItem>
          </div>

          <div v-if="!isLifeTariff" class="step-three__item form__item">
            <ElFormItem class="step-three__item-col form__col" prop="currectObject">
              <ElCheckboxGroup v-model="propertyForm.currectObject">
                <div class="step-three__item-checkbox">
                  <ElCheckbox name="currectObject" />
                  <span class="tep-three__item-checkbox-text">
                    Подтверждаю отсутствие на объекте страхования деревянных конструктивных элементов, не согласованных с БТИ перепланировок, ведения на территории строительных и ремонтных работ. Объект не является памятником архитектуры, не сдается в аренду, находится не в аварийном состоянии и не в зоне экологического бедствия
                  </span>
                </div>
              </ElCheckboxGroup>
            </ElFormItem>
          </div>

          <div v-if="!isPropertyTariff" class="step-three__item form__item">
            <ElFormItem class="step-three__item-col form__col" prop="agreement">
              <ElCheckboxGroup v-model="propertyForm.agreement">
                <div class="step-three__item-checkbox">
                  <ElCheckbox name="agreement" />
                  <span class="tep-three__item-checkbox-text">
                    Подтверждаю получение образца полиса с условиями страхования, полноту и достоверность предоставленных данных в <a
                      href="#" download>договоре личного страхования</a>
                </span>
                </div>
              </ElCheckboxGroup>
            </ElFormItem>
          </div>

          <div v-if="isPropertyTariff" class="step-three__item form__item">
            <ElFormItem class="step-three__item-col form__col" prop="keyInformationDocument">
              <ElCheckboxGroup v-model="propertyForm.keyInformationDocument">
                <div class="step-three__item-checkbox">
                  <ElCheckbox name="keyInformationDocument" />
                  <span class="tep-three__item-checkbox-text">
                    Подтверждаю, что был ознакомлен c <a href="#" download>ключевым информационным документом (КИД)</a> до заключения договора страхования и получил его. Подтверждаю получение образца полиса с условиями страхования, полноту и достоверность предоставленных данных <a href="#" download>в договоре имущественного страхования</a>
                </span>
                </div>
              </ElCheckboxGroup>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem class="step-three__item-col form__col" prop="policy">
              <ElCheckboxGroup v-model="propertyForm.policy">
                <div class="step-three__item-checkbox">
                  <ElCheckbox name="policy" />
                  <span class="tep-three__item-checkbox-text">
                  Даю согласие на обработку персональных данных в соответствии с <a href="#" download>политикой в отношении обработки персональных данных</a>
                </span>
                </div>
              </ElCheckboxGroup>
            </ElFormItem>
          </div>

          <div class="step-three__item form__item">
            <ElFormItem class="step-three__item-col form__col" prop="rules">
              <ElCheckboxGroup v-model="propertyForm.rules">
                <div class="step-three__item-checkbox">
                  <ElCheckbox name="rules" />
                  <span class="tep-three__item-checkbox-text">
                  Согласен с <a href="#" download>правилами страхования</a>
                </span>
                </div>
              </ElCheckboxGroup>
            </ElFormItem>
          </div>
        </section>
      </ElForm>
    </div>
  </div>
</template>

<script>
import { numbersLengthFromString, matchesEmailRegex} from '@/utils/string-helpers';
import BaseButton from '@/components/ui/BaseButton';
import ResultCard from '@/components/pages/index/InsuranceProcess/ResultCard';
import SvgIcon from "@/components/ui/SvgIcon.vue";
import { PHONE_LENGTH, PERSON_PASSPORT_LENGTH, DEPARTMENT_CODE_LENGTH } from "@/consts";
import {validationHandler} from "@/utils/validation";
import {calculatorEipoteka, getIssuedByPassport} from "@/api/routes/calculator-eipoteka";
import { fetchFioSuggestions, fetchAddressSuggestions } from '@/utils/api-helpers';

export default {
  name: 'Step3',
  components: {
    SvgIcon,
    ResultCard,
    BaseButton,
  },
  props: {
    tariffs: Object,
    formData: Object,
    prepareData: Object,
    tariffType: String,
  },
  data() {
    return {
      propertyForm: {
        fio: '',
        birthDate: '12.12.1994',
        gender: 'Мужской',
        height: '',
        weight: '',
        lowPressure: '',
        highPressure: '',
        phone: '',
        email: '',
        passportNumber: '',
        passportDate: '',
        departmentCode: '',
        issuedBy: '',
        registrationAddress: '',
        registrationAddressKladr: '',
        registrationKladrHouse: '',
        registrationApartmentNumber: '',
        creditBalance: '100 000 ₽',
        interestRate: '',
        loanAgreementNumber: '',
        manualAnnuity: '',
        credit_date: '',
        dateLoanStart: '',
        sameRegisteredAddress: false,
        currectObject: [],
        keyInformationDocument: [],
        policy: [],
        rules: [],
        personalPolicy: [],
        questionnaire: [],
        agreement: [],
        registrationObjectAddress: '',
        registrationObjectAddressKladr: '',
        registrationObjectKladrHouse: '',
        registrationObjectFlat: '',
        yearHouseBuilt: '',
        numberFloorsHouse: '',
        square: '',
        wallMaterials: '',
      },
      rules: {
        fio: [
          { required: true, message: 'Поле ФИО обязательно для заполнения', trigger: 'blur' },
        ],
        birthDate: [
          { required: true, message: 'Поле дата рождения обязательно для заполнения', trigger: 'blur' },
        ],
        gender: [
          { required: true, message: 'Поле пол обязательно для заполнения', trigger: 'blur' },
        ],
        highPressure: [
          { required: true, message: 'Поле артериальное давление (верхнее) обязательно для заполнения', trigger: 'blur' },
        ],
        lowPressure: [
          { required: true, message: 'Поле артериальное давление (нижнее) обязательно для заполнения', trigger: 'blur' },
        ],
        weight: [
          { required: true, message: 'Поле рост обязательно для заполнения', trigger: 'blur' },
        ],
        hight: [
          { required: true, message: 'Поле рост обязательно для заполнения', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: 'Поле телефона обязательно для заполнения', trigger: 'blur' },
          {
            validator: (rule, val, resolve) => validationHandler(this.phoneLengthIsValid, `Номер телефона должен содержать ${PHONE_LENGTH} символов`, resolve),
            trigger: 'blur'
          },
        ],
        email: [
          { required: true, message: 'Поле почты обязательно для заполнения', trigger: 'blur' },
          {
            validator: (rule, val, resolve) => validationHandler(this.emailFormatIsValid, 'Неверный формат электронной почты!', resolve),
            trigger: 'blur'
          },
        ],
        passportNumber: [
          { required: true, message: 'Поле серия и номер паспорта обязательно для заполнения', trigger: 'blur' },
          {
            validator: (rule, val, resolve) => validationHandler(this.passportIsValid, `Данные должны содержать ${PERSON_PASSPORT_LENGTH} символов`, resolve),
            trigger: 'blur'
          },
        ],
        passportDate: [
          { required: true, message: 'Поле дата выдачи обязательно для заполнения', trigger: 'blur' },
        ],
        departmentCode: [
          { required: true, message: 'Поле код подразделения обязательно для заполнения', trigger: 'blur' },
          {
            validator: (rule, val, resolve) => validationHandler(this.departmentCodeIsValid, `Данные должны содержать ${DEPARTMENT_CODE_LENGTH} символов`, resolve),
            trigger: 'blur'
          },
        ],
        issuedBy: [
          { required: true, message: 'Поле кем выдан обязательно для заполнения', trigger: 'blur' },
        ],
        registrationAddress: [
          { required: true, message: 'Поле адреса обязательно для заполнения', trigger: 'blur' },
          {
            validator: (rule, val, resolve) => validationHandler(this.addressIsValid, this.addressError, resolve),
            trigger: 'blur'
          }
        ],
        creditBalance: [
          { required: true, message: 'Поле остаток кредита обязательно для заполнения', trigger: 'blur' },
        ],
        interestRate: [
          { required: true, message: 'Поле процентная ставка обязательно для заполнения', trigger: 'blur' },
        ],
        loanAgreementNumber: [
          { required: true, message: 'Поле номер кредитного договора обязательно для заполнения', trigger: 'blur' },
        ],
        manualAnnuity: [
          { required: true, message: 'Поле ежемесячный платеж обязательно для заполнения', trigger: 'blur' },
        ],
        credit_date: [
          { required: true, message: 'Поле дата заключения кредитного договора обязательно для заполнения', trigger: 'blur' },
        ],
        dateLoanStart: [
          { required: true, message: 'Поле дата начала договора страхования договора обязательно для заполнения', trigger: 'blur' },
        ],
        sameRegisteredAddress: [
          { required: false },
        ],
        currectObject: [
          { type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change' },
        ],
        keyInformationDocument: [
          { type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change' },
        ],
        policy: [
          { type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change' },
        ],
        rules: [
          { type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change' },
        ],
        personalPolicy: [
          { type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change' },
        ],
        questionnaire: [
          { type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change' },
        ],
        agreement: [
          { type: 'array', required: true, message: 'Поле обязательно для заполнения', trigger: 'change' },
        ],
        registrationObjectAddress: [
          { required: true, message: 'Поле адреса обязательно для заполнения', trigger: 'blur' },
          {
            validator: (rule, val, resolve) => validationHandler(this.addressIsValidObject, this.addressErrorObject, resolve),
            trigger: 'blur'
          }
        ],
        yearHouseBuilt: [
          { required: true, message: 'Поле год постройки дома обязательно для заполнения', trigger: 'blur' },
        ],
        numberFloorsHouse: [
          { required: true, message: 'Поле этажность дома обязательно для заполнения', trigger: 'blur' },
        ],
        square: [
          { required: true, message: 'Поле площадь обязательно для заполнения', trigger: 'blur' },
        ],
        wallMaterials: [
          { required: true, message: 'Поле материал стен обязательно для заполнения', trigger: 'blur' },
        ],
      },
      wallMaterials: [],
      stepThreeSessionData: null,
    }
  },
  computed: {
    emailFormatIsValid() {
      return matchesEmailRegex(this.propertyForm.email);
    },
    phoneLengthIsValid() {
      return numbersLengthFromString(this.propertyForm.phone) >= PHONE_LENGTH
    },
    passportIsValid() {
      return numbersLengthFromString(this.propertyForm.passportNumber) >= PERSON_PASSPORT_LENGTH;
    },
    departmentCodeIsValid() {
      return numbersLengthFromString(this.propertyForm.departmentCode) >= DEPARTMENT_CODE_LENGTH;
    },
    allInsuranceCost() {
      const summ = this.tariffs.reduce((acc, current) => {
        if (current.isSelected) {
          return acc + current.sumPrem;
        }

        return acc + (current.isSelected) ? current.sumPrem : 0;
      }, 0);

      return `${summ ? summ.toFixed(2) : 0} ₽`;
    },
    isPropertyTariff() {
      return this.tariffType === 'property';
    },
    isLifeTariff() {
      return this.tariffType === 'life';
    },
    fio() {
      return this.propertyForm.fio;
    },
    addressIsValid() {
      if (!!!this.propertyForm.registrationAddressKladr || !!!this.propertyForm.registrationKladrHouse) {
        return false;
      }

      return true;
    },
    addressError() {
      if (!!!this.propertyForm.registrationAddressKladr || !!!this.propertyForm.registrationKladrHouse) {
        return 'Некорректный адрес, выберите адрес из списка';
      }
      return 'Поле обязательно для заполнения'
    },
    addressIsValidObject() {
      if (!!!this.propertyForm.registrationObjectAddressKladr || !!!this.propertyForm.registrationObjectKladrHouse) {
        return false;
      }

      if (
        !!!this.propertyForm.registrationObjectFlat
        && (this.prepareData.objectTypeId === 'd7db580c-d39b-426f-9604-ad9be2dfcd72' || this.prepareData.objectTypeId === 'd8a6c323-2e6c-4921-abd9-7288a78d3f7d')
      ) {
        return false;
      }

      return true;
    },
    addressErrorObject() {
      if (!!!this.propertyForm.registrationObjectAddressKladr || !!!this.propertyForm.registrationObjectKladrHouse) {
        return 'Некорректный адрес, выберите адрес из списка';
      }

      if (
        !!!this.propertyForm.registrationObjectFlat
        && (this.prepareData.objectTypeId === 'd7db580c-d39b-426f-9604-ad9be2dfcd72' || this.prepareData.objectTypeId === 'd8a6c323-2e6c-4921-abd9-7288a78d3f7d')
      ) {
        return 'Некорректный адрес, не указан номер квартиры/комнаты';
      }

      return 'Поле обязательно для заполнения'
    },
    fetchFioSuggestions,
    fetchAddressSuggestions,
  },
  methods: {
    getDisabledStartDate(date) {
      let currentDay = Date.now();
      let maxLimitDay = new Date();
      let numberOfDaysToAdd = 45;
      maxLimitDay.setDate(maxLimitDay.getDate() + numberOfDaysToAdd);
      return date.getTime() < currentDay || date.getTime() > maxLimitDay.getTime();
    },
    submitHandler(formEl) {
      formEl.validate(valid => {
        if (valid) {
          this.$emit('step-three-submit', this.propertyForm);
        }
      })
    },
    formSelectHandler(data, formField) {
      this.propertyForm[formField] = data;

      this.$refs.propertyFormRef.validateField(formField);
    },
    MaterialBlurHandler() {
      this.$refs.propertyFormRef.validateField('wallMaterials');
    },
    async getIssuedByHandler() {
      let data = await getIssuedByPassport(this.propertyForm.departmentCode);
      if (data?.result) {
        if (data?.response?.name?.length > 0) {
          this.propertyForm.issuedBy = data.response.name
        }
      }
    },
    clearParams(val) {
      this.propertyForm.registrationKladrHouse = '';
      this.propertyForm.registrationAddressKladr = '';
    },
    clearParamsObject(val) {
      this.propertyForm.registrationObjectAddressKladr = '';
      this.propertyForm.registrationObjectKladrHouse = '';
      this.propertyForm.registrationObjectFlat = '';
    },
    handleSelect(item) {
      this.propertyForm.registrationKladrHouse = item.houseKladrId;
      this.propertyForm.registrationAddressKladr = item.kladrId;
      this.propertyForm.registrationApartmentNumber = !!item?.flat ? item.flat : '';

      this.$refs.propertyFormRef.validateField('registrationAddress');
    },
    handleSelectObject(item) {
      this.propertyForm.registrationObjectAddressKladr = item.kladrId;
      this.propertyForm.registrationObjectKladrHouse = item.houseKladrId;
      this.propertyForm.registrationObjectFlat = item.flat;

      this.$refs.propertyFormRef.validateField('registrationObjectAddress');
    },
    sameRegistreredAddressHandler(val) {
      if (val) {
        this.propertyForm.registrationObjectAddressKladr = this.propertyForm.registrationAddressKladr;
        this.propertyForm.registrationObjectKladrHouse = this.propertyForm.registrationKladrHouse;
        this.propertyForm.registrationObjectAddress = this.propertyForm.registrationAddress;
        this.propertyForm.registrationObjectFlat = this.propertyForm.registrationApartmentNumber;

        this.$refs.propertyFormRef.validateField('registrationObjectAddress');
      }
    }
  },
  async mounted() {
    this.stepThreeSessionData = await calculatorEipoteka('getSessionData');

    this.propertyForm = {
      ...this.propertyForm,
      ...this.stepThreeSessionData.stepThree,
      creditBalance: this.formData.credit_balance,
      birthDate: this.formData.birth_date,
      credit_date: this.formData.credit_date,
      gender: this.formData.gender === 'F' ? 'женский' : 'Мужской',
    }

    const materialsResponseData = await calculatorEipoteka('getMaterialsAction');

    if (!materialsResponseData.result) {
      this.wallMaterials= []
    } else {
      this.wallMaterials = materialsResponseData.response;
    }

  },
}
</script>

<style lang="scss" scoped>
.step-three {
  &__result {
    height: 100%;
  }

  &__form {
    &-section {
      &:not(:last-child) {
        margin-bottom: rem(24);
      }
    }
  }

  &__item {
    &-checkbox {
      @include text-props(16px, 19.36px);

      display: flex;

      @media #{$screen-small} {
        @include text-props(14px, 16.94px);
      }

      :deep(.tep-three__item-checkbox-text) {
        &:not(:first-child) {
          padding-left: rem(8);
        }
      }
    }
  }
}
</style>

